import { Subscription } from "./subscription";

export class License {
    id: number;
    license_group_id: number;
    license: string;
    code: string;
    is_active: boolean;
    starts_at: string;
    expires_at: string;
    updated_at: string;

    public static createMany(data: any[]): License[] {
        let licenses: License[] = [];
        for (let item of data) {
            licenses.push(License.createOne(item));
        }
        return licenses;
    }

    public static createOne(data: any): License {
        if (!data) return null;
        let license = new License();
        license.fill(data);
        return license;
    }

    public fill(data: any) {
        this.id = data.id || null;
        this.license_group_id = data.license_group_id || null;
        this.license = data.license || null;
        this.code = data.code || null;
        this.is_active = data.code || false;
        this.starts_at = data.starts_at || null;
        this.expires_at = data.expires_at || null;
        this.updated_at = data.updated_at || null;
    }
}



// WEBPACK FOOTER //
// ./src/models/License.ts